import { supportedURLIcons } from './supportedURLIcons';

export const resolveURLIcon = url =>
  supportedURLIcons.find(({ pattern }) => new RegExp(pattern).test(url));
